import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs, TextArea} from 'coaz-ui';
import client from '../client';

const AddCourse = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const programId = params ? params.programId : null;
    const approvedCpds = params && params.approvedCpds ? params.approvedCpds : [];
    const [course,setCourse] = useState({});
    const [program,setProgram] = useState(null);
    const [criteriaPaths,setCriteriaPaths] = useState([]);
    const minWidth = 240;
    const {request,errorMessage} = client;

    const programApprovedCpds = approvedCpds.filter((cpd) => {return cpd.programId == programId});
    const matchedCpds = programApprovedCpds.filter((cpd) => {return course.name && cpd.name && cpd.name.toLowerCase() === course.name.toLowerCase()});
    const pointsOptions = [...new Set((matchedCpds.length > 0?matchedCpds:programApprovedCpds).map((cpd) => cpd.points))];

    const submit = async (e) => {
        try {
            const response = await request('POST', 'cpds', {...course, program: program});

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            console.log(error.response && error.response.data);
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const onChange = (e) => {
        const value = e.target.value;
        setCourse(prev => ({ ...prev, [e.target.name]: value === '' ? null : value }));
    };

    const onName = (e) => {
        const value = e.target.value;
        if (value === '') {
            setCourse(prev => ({ ...prev, name: null }));
            return;
        }
        const match = programApprovedCpds.find(
            (cpd) => cpd.name && cpd.name.toLowerCase() === value.toLowerCase()
        );
        setCourse(prev => ({
            ...prev,
            name: value,
            ...(match ? { points: match.points } : {}),
        }));
    };

    const onNumber = (e) => {
        const value = e.target.value;
        if (isNaN(value)) return;
        setCourse(prev => ({ ...prev, [e.target.name]: value === '' ? null : value }));
    };

    const onDate = (e) => {
        setCourse(prev => ({ ...prev, [e.target.name]: new Date(e.target.value) }));
    };

    const onCriteriaPath = (e) => {
        if (e.target.value === '') {
            setCourse(prev => ({ ...prev, criteriaPathItemId: null }));
        } else {
            const value = criteriaPaths.find((path) => path.id == e.target.value);
            setCourse(prev => ({ ...prev, criteriaPathItemId: value.id }));
        }
    };

    const inputs = [
        {
            label:'Program',
            type:'text', 
            name:'program',
            value:program && program.name?program.name:'',   
            placeholder:'Progam name...',
            disabled:true
        },
        {
            label:'Name',
            type:'text', 
            name:'name',
            value:course && course.name?course.name:'',   
            placeholder:'Enter name...',
            onChange:(e) => {handleChange(e,onName)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'External Id',
            type:'number', 
            name:'externalId',
            value:course && course.externalId?course.externalId:'',   
            placeholder:'Enter external id...',
            onChange:(e) => {handleChange(e,onNumber)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Points',
            type:'number', 
            name:'points',
            list:'hpcz_points',
            value:course && course.points?course.points:'',   
            placeholder:'Select or enter points...',
            onChange:(e) => {handleChange(e,onNumber)}
        },
        {
            label:'Available from',
            type:'date',
            name:'availableFrom', 
            value:course && course.availableFrom?course.availableFrom.toISOString().slice(0, 10):'',
            placeholder:'Available from...',
            onChange:(e) => handleChange(e,onDate)
        },
        {
            label:'Available upto',
            type:'date',
            name:'availableTo', 
            value:course && course.availableTo?course.availableTo.toISOString().slice(0, 10):'',
            placeholder:'Available upto...',
            onChange:(e) => handleChange(e,onDate)
        },
        {
            label:'Visible when unavailable',
            type:'checkbox',
            name:'visibleWhenUnavailable',
            value:course?course.visibleWhenUnavailable:false,   
            onChange:(e) => {
                setCourse({...course,visibleWhenUnavailable: !course.visibleWhenUnavailable});
            }
        },
        {
            label:'Tariff Applicable',
            type:'checkbox',
            name:'tariffApplicable',
            value:course?course.tariffApplicable:false,   
            onChange:(e) => {
                setCourse({...course,tariffApplicable: !course.tariffApplicable});
            }
        },
        {
            label:'Criteria paths',
            type:'select',
            options:() => {
                let options = [];
                course && course.tariffApplicable && criteriaPaths.map((option,i) => options.push(<option key={i} value={option.id}>{option.id}</option>));
                return options;
            },
            name:'criteriaPathItem', 
            value:course && course.criteriaPathItemId?course.criteriaPathItemId:'',
            disabled:course && !course.tariffApplicable,
            onChange:(e) => handleChange(e,onCriteriaPath)
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        (async () => {
            setLoading && setLoading(true);
            try {
                const response = await request('GET', `programs/${programId}`);
                if (response && response.ref) {
                    setProgram(response);
                }
            } catch (error) {
                console.log(error);
            }

            try {
                const paths = await request('GET', 'criteria-path-items', null, null, false, 'auth/api');
                if (paths && paths.length > 0) {
                    setCriteriaPaths(paths);
                    setCourse(prev => ({ ...prev, criteriaPathItemId: paths[0].id }));
                } else {
                    setCriteriaPaths([]);
                }
            } catch (error) {
                console.log(error);
            }

            setLoading && setLoading(false);
        })();
    }, [programId]);

    return (
        <FormValidator>
            {course && <div className='flex flex-col w-full h-auto'>
                <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                <datalist id='hpcz_points'>
                    {pointsOptions.map((points,i) => <option key={i} value={points}/>)}
                </datalist>
                <TextArea
                    label='Description'
                    id='description'
                    name='description'
                    value={course.description?course.description:''}
                    placeholder='Enter description'
                    onChange={(e) => handleChange(e,onChange)}
                />
            </div>}
        </FormValidator>
      )
}

export default AddCourse